import React from "react";
import Chip from '@mui/material/Chip';
import { useTheme } from "@mui/material/styles";
import {
  ORDER_STATE_CANCELLED,
  ORDER_STATE_PLACED,
  ORDER_STATE_ACCEPTED,
  ORDER_STATE_DELIVERED,
  ORDER_STATE_FULFILLED,
  ORDER_STATE_AGENT_ASSIGNED,
  ORDER_STATE_PICKED_UP,
  ORDER_STATE_OUT_FOR_DELIVERY,
} from "../../../constants/string";

const StatusSymbol = ({ stateName }) => {
  const theme = useTheme();
  let chipColor;
  let bordercolor;
  switch (stateName) {
    case ORDER_STATE_CANCELLED:
      chipColor = '#FFEDE9';
      bordercolor = '#EA4722'
      break;
    case ORDER_STATE_ACCEPTED:
      chipColor = '#DAE8FF';
      bordercolor = '#003FA4'
      break;
    case ORDER_STATE_FULFILLED:
      chipColor = '#FFEFFF';
      bordercolor = '#EE00EE'
      break;
    case ORDER_STATE_DELIVERED:
      chipColor = '#EFFFF0';
      bordercolor = '#16995A'
      break;
    case ORDER_STATE_PLACED:
      chipColor = '#FFFCEF';
      bordercolor = '#F9A540'
      break;
    case ORDER_STATE_AGENT_ASSIGNED:
      chipColor = '#EFFFFD';
      bordercolor = '#00ECCF'
      break;
    case ORDER_STATE_PICKED_UP:
      chipColor = '#FFEFE0';
      bordercolor = '#FF7B00'
      break;
    case ORDER_STATE_OUT_FOR_DELIVERY:
      chipColor = '#F7EFFF';
      bordercolor = '#8000FF'
      break;      
    default:
      chipColor = theme.palette.grey[400]; // Default color if none of the states match
  }

  return (
    <Chip
      label={stateName}
      variant="outlined"
      sx={{
        backgroundColor: chipColor,
        borderColor: bordercolor,
      }}
    />
  );
};

export default StatusSymbol;
